var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('div',{staticClass:"avatar-md profile-user-wid mb-4"},[_c('span',{staticClass:"avatar-title rounded-circle bg-light"},[_c('img',{staticClass:"rounded-circle",attrs:{"src":"/images/rb-favicon.png","alt":"Resourcebase","height":"34"}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }